<template>
  <div v-if="isLoaded" class="body">
    <div class="skipNavigation">
      <button id="go-contents" type="button" tabindex="-1">
        탭 포커스 초기화
      </button>
      <a href="#contents">본문 바로가기</a>
      <a href="#menu">메뉴 바로가기</a>
    </div>
    <WHeader />
    <RouterView :key="`${$route.path}${componentKey}`" name="homeBodyContent" />
    <RouterView :key="$route.path + componentKey" name="bodyContent" />
    <RouterView key="search" name="searchContent" />
    <RouterView name="myPooqLayout" />
    <RouterView name="voucherLayout" />
    <RouterView :key="$route.fullPath + componentKey" name="customerLayout" />
    <RouterView key="adult_contents" name="adult_contents" />
    <PpvToast />
    <BtnTop />
    <AppFooter />
  </div>
</template>

<script>
  import WHeader from '@/components/header/WHeader'
  import AppFooter from '@/components/common/AppFooter'
  import BtnTop from '@/components/button/BtnTop'
  import { mapGetters } from 'vuex'
  import {
    UPDATE_MAIN_LAYOUT_CONTENT,
    UPDATE_PAGING_CONTENT,
  } from '@/common/resources/const'
  import {
    changeViewPort,
    VIEWPORT_VALUE_PC_APP_MODE,
  } from '@/common/utils/viewport.utils'
  import { autoLoginProc } from '@/common/utils/login'
  import _ from 'lodash'
  import PpvToast from '@/components/movie/PpvToast'
  import braze from '@/common/utils/braze'
  import { getUserExternalId } from '@/common/utils/braze.util'
  import { datadogRum } from '@datadog/browser-rum'
  import cookie from '@/common/utils/cookie'

  export default {
    name: 'MainLayout',
    components: {
      PpvToast,
      AppFooter,
      BtnTop,
      WHeader,
    },
    data() {
      return {
        componentKey: 0,
        isLoaded: true,
      }
    },
    computed: {
      ...mapGetters(['currentMenu']),
    },
    mounted() {
      this.$events.$on(UPDATE_PAGING_CONTENT, () => {
        this.componentKey += 1
      })
      this.$events.$on(UPDATE_MAIN_LAYOUT_CONTENT, () => {
        this.componentKey += 1
      })
    },
    beforeDestroy() {
      this.$events.$off(UPDATE_PAGING_CONTENT)
      this.$events.$off(UPDATE_MAIN_LAYOUT_CONTENT)
    },
    created() {
      this.autoLogin()
      changeViewPort(VIEWPORT_VALUE_PC_APP_MODE)
    },
    methods: {
      autoLogin() {
        this.isLoaded = false
        const autoLogin = autoLoginProc()
        const isThenable = _.get(autoLogin, 'then', false)
        if (isThenable) {
          try {
            autoLogin
              .then(() => {
                window.location.reload()
              })
              .catch((e) => {
                console.log(e)
                this.isLoaded = true
              })
          } catch (e) {
            this.isLoaded = true
            console.log(e)
          }
        } else {
          braze.connectUser(getUserExternalId())
          datadogRum.setUser({ uno: cookie.getUno() })
          this.isLoaded = true
        }
      },
    },
  }
</script>
<style lang="scss" src="@/assets/scss/category/main.scss"></style>
<style lang="scss" src="@/assets/scss/category/search.scss"></style>
